import { Location } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, map, Observable, tap } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AppUser, Permission } from 'src/app/core/models/users.model';
import Swal from 'sweetalert2';
import { DoctorService } from '../../doctors/service/doctor.service';
import { InsuranceService } from '../../../../core/services/insurances.service';
import { NoteBcbaService } from '../../../../core/services/notes-bcba.service';
import { NoteRbtService } from '../../../../core/services/notes-rbt.service';
import { ClientReportModel } from '../client-report.model';
import { ClientReportService } from '../client-report.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppRoutes } from 'src/app/shared/routes/routes';
import { Insurance, LocationInsurance } from '../../location/models/locations.model';
import { PaService } from 'src/app/shared/interfaces/pa-service.interface';
import { PermissionsUtils } from 'src/app/shared/utils/permissions.utils';

export interface InsuranceCptPrizeResponse {
  unit_price: number;
}

export interface NoteBcba {
  cpt_code: string;
}

export interface NoteRbt {
  cpt_code: string;
}

interface ReportNote {
  id?: number | string;
  session_date?: string | Date;
  created_at?: string | number | Date | null;
  total_hours?: string;
  total_units?: number;
  session_units_total?: number;
  meet_with_client_at?: string;
  cpt_code?: string;
  tecnicoRbt?: {
    name?: string;
    surname?: string;
  };
  md?: string;
  md2?: string;
  mdbcba?: string;
  md2bcba?: string;
  pos?: string;
  provider_name_g?: string;
  billed?: number;
  pay?: number;
  billedbcba?: number;
  paybcba?: number;
  status?: string;
  amount?: number;
  supervisor?: string | { npi?: string | number };
  tecnicoRbts?: string;
}

interface CombinedRow {
  rbt: ReportNote | null;
  bcba: ReportNote | null;
  pos?: string;
  total_hours?: string;
}

@Component({
  selector: 'app-report-by-client',
  templateUrl: './report-by-client.component.html',
  styleUrls: ['./report-by-client.component.scss'],
})
export class ReportByClientComponent implements OnInit {
  private readonly ativatedRoute = inject(ActivatedRoute);
  private readonly clientReportService = inject(ClientReportService);
  private readonly doctorService = inject(DoctorService);
  private readonly authService = inject(AuthService);
  private readonly insuranceService = inject(InsuranceService);
  private readonly noteRbtService = inject(NoteRbtService);
  private readonly noteBCbaService = inject(NoteBcbaService);
  private readonly location = inject(Location);

  routes = AppRoutes;
  searchDataDoctor = '';
  date_start: string | null = null;
  date_end: string | null = null;

  patient_id: number | string | null = null;
  billing_selected: number | string | null = null;
  sponsor_id: number | null = null;
  noterbt_id: number | null = null;
  user!: AppUser;

  clientReport: ClientReportModel = new ClientReportModel();

  clientReportList: ReportNote[] = [];
  clientReport_generals: ReportNote[] = [];
  dataSource!: MatTableDataSource<ReportNote>;
  showFilter = false;
  searchDataValue = '';
  lastIndex = 0;
  pageSize = 50;
  totalDataClientReport = 0;
  skip = 0;
  limit: number = this.pageSize;
  pageIndex = 0;
  serialNumberArray: number[] = [];
  currentPage = 1;
  pageNumberArray: number[] = [];
  pageSelection: { skip: number; limit: number }[] = [];
  totalPages = 0;
  text_validation: string | null = null;

  roles: string[] = [];
  permissions: string[] = [];
  patientID: number | null = null;
  patientId: string | null = null;

  pa_assessments: unknown = null;
  pa_assessmentsgroup: Array<{ serial_number?: number }> = [];
  cpt = '';
  n_units: number | null = null;
  pa_number: string | number | null = null;
  insurances: LocationInsurance[] = [];
  insurance_id: number | null = null;
  insuranceiddd: string | null = null;
  insurer_name = '';
  modifiers: unknown[] = [];
  noteRbt: ReportNote[] = [];
  pos_covered: unknown[] = [];
  pa_assessmentgroup: unknown[] = [];
  noteBcba: ReportNote[] = [];
  patient: unknown;

  patientName = '';
  doctor_selected_full_name = '';
  billing_total: number | null = null;
  week_total_hours = '';
  week_total_units: number | null = null;
  total_hours: number | null = null;
  total_units: number | null = null;
  charges: number | null = null;
  unitPrize = 0;
  unitPrizeCpt: number | null = null;
  xe = 0;
  xp = 0;
  is_xe = false;
  is_xp = false;

  session_date: string | Date | null = null;
  time_in: string | null = null;
  time_out: string | null = null;
  time_in2: string | null = null;
  time_out2: string | null = null;
  pos: string | null = null;
  billed = false;
  pay = false;
  billedbcba = false;
  paybcba = false;
  md: string | null = null;
  md2: string | null = null;
  mdbcba: string | null = null;
  md2bcba: string | null = null;
  pay_selected: boolean | null = null;
  billed_selected: boolean | null = null;
  total: number | null = null;
  totalPorPagar: number | null = null;
  resultconFactor: number | null = null;
  unidades: number | null = null;
  porPagar: number | null = null;
  horaTrabajada: number | null = null;
  factHoras: number | null = null;
  totalHoras: number | null = null;
  totalUnidades: number | null = null;
  units: number | null = null;
  hoursPerUnit: number | null = null;
  timePerUnit: number | null = null;

  tecnicoRbts: string | null = null;
  supervisor: string | null = null;
  npi: string | number | null = null;
  rbt_id: number | null = null;
  rbt2_id: number | null = null;
  bcba_id: number | null = null;
  bcba2_id: number | null = null;
  doctor_selected_bcba: unknown;
  full_name = '';
  doctors: unknown;
  tecnicoDoctorNames: unknown;

  services: Array<{ provider?: string; code?: string; unit_price?: number }> = [];
  provider = '';
  selectedCpt: string | null = null;
  // data: any;
  noteType = '';

  providersSponsorsList: unknown;
  factorPorcentual = 1.66666666666667;

  doctor_selected: unknown = null;
  combinedList: CombinedRow[] = [];
  unitPrizeCptBcba: number | null = null;
  unitPrizeCptRbt: number | null = null;
  bcbaCptCode = '';
  rbtCptCode = '';

  paServices: PaService[] = [];

  ngOnInit(): void {
    //
    this.ativatedRoute.params.subscribe((resp) => {
      this.patient_id = resp['patient_id'];
      this.patientId = String(resp['patient_id'] ?? '');
      console.log(this.patient_id);
    });

    this.getConfig();
    this.billed = false;
    this.pay = false;
    this.billedbcba = false;
    this.paybcba = false;

    this.user = this.authService.user as AppUser;
    this.getTableData();
  }

  goBack() {
    this.location.back(); // <-- go back to previous location on cancel
  }

  isPermission(permission: Permission) {
    if (this.user.roles.includes('SUPERADMIN')) {
      return true;
    }
    if (this.user.roles.includes('ADMIN')) {
      return true;
    }
    return PermissionsUtils.hasPermission(this.user.permissions, permission);
  }

  getConfig() {
    this.clientReportService.config().subscribe((resp) => {
      // console.log(resp);
      this.insurances = resp.insurances;
    });
  }

  getTableData(page = 1): void {
    this.clientReportList = [];
    this.serialNumberArray = [];
    this.currentPage = page;

    // this.patientId = patient_id
    // // this.patientId = 'cliente3243';

    this.clientReportService
      .getAllClientReportByPatient(
        this.patientId ?? '',
        page,
        this.date_start ?? '',
        this.date_end ?? '',
        this.noteType
      )
      .subscribe((resp) => {
        // console.log('todo',resp);
        const response = resp as {
          arrayPages: number[];
          patient: {
            full_name?: string;
            patient_id?: number | string;
            insurer_id?: number | string;
            rbt_id?: number | string;
            rbt2_id?: number | string;
            bcba_id?: number | string;
            bcba2_id?: number | string;
          };
          noteRbts: Array<{
            supervisor?: string;
            tecnicoRbts?: string;
          }>;
          noteBcbas: ReportNote[];
          pos_covered: unknown;
          doctors: unknown;
          pa_services: unknown;
          patient_id: number | string;
        };

        const pa = response.arrayPages;
        // const pa = [1,2,3,4,5,6,7,8,9,10]
        this.pageNumberArray = [];
        if (pa.length > 5) {
          if (this.currentPage > 2 && this.currentPage < pa.length - 2) {
            for (
              let index = this.currentPage - 2;
              index < this.currentPage + 3;
              index++
            ) {
              this.pageNumberArray.push(index);
            }
          } else if (this.currentPage <= 2) {
            for (let index = 1; index < 6; index++) {
              this.pageNumberArray.push(index);
            }
          } else if (this.currentPage >= pa.length - 2) {
            for (let index = pa.length - 4; index <= pa.length; index++) {
              this.pageNumberArray.push(index);
            }
          }
        } else {
          this.pageNumberArray = pa;
        }
        // traemos la info necesaria del paciente
        this.patientName = response.patient.full_name || '';
        this.patientID = Number(response.patient.patient_id || 0);
        this.insurance_id = Number(response.patient.insurer_id || 0);
        this.billed = response.noteRbts.length > 0;
        this.pay = response.noteRbts.length > 0;
        this.billedbcba = response.noteBcbas.length > 0;
        this.paybcba = response.noteBcbas.length > 0;
        this.pos_covered = response.pos_covered as typeof this.pos_covered;

        // obtengo la info resumida de las notas rbt
        this.noteRbt = response.noteRbts;

        // aqui traigo los nombres de los doctores relacionados al paciente
        this.doctors = response.doctors;
        this.supervisor =
          response.noteRbts.length > 0
            ? String(response.noteRbts[0].supervisor ?? '')
            : null;
        this.tecnicoRbts =
          response.noteRbts.length > 0
            ? response.noteRbts[0].tecnicoRbts ?? null
            : null;

        this.noteBcba = response.noteBcbas;

        //unimos las notas rbt y bcba para mostrarlas en la misma tabla
        const clientReportList =
          this.noteRbt.length > this.noteBcba.length
            ? this.noteRbt
            : this.noteBcba;

        this.combinedList = [];
        clientReportList.forEach((item, index) => {
          // console.log(this.noteRbt[index])
          // console.log(this.noteBcba[index])
          if (this.noteRbt[index] && this.noteBcba[index])
            this.combinedList.push({
              rbt: this.noteRbt[index],
              bcba: this.noteBcba[index],
            });
          else if (this.noteRbt[index])
            this.combinedList.push({ rbt: this.noteRbt[index], bcba: null });
          else if (this.noteBcba[index])
            this.combinedList.push({ rbt: null, bcba: this.noteBcba[index] });
        });

        //fin union

        this.rbt_id = Number(response.patient.rbt_id || 0);
        this.rbt2_id = Number(response.patient.rbt2_id || 0);
        this.bcba_id = Number(response.patient.bcba_id || 0);
        this.bcba2_id = Number(response.patient.bcba2_id || 0);

        this.paServices = response.pa_services as typeof this.paServices;

        this.totalDataClientReport = response.noteRbts.length;
        this.clientReport_generals = response.noteRbts;

        this.patient_id = Number(response.patient_id || 0);

        for (let i = 0; i < this.pa_assessmentsgroup.length; i++) {
          const serialNumber = this.pa_assessmentsgroup[i].serial_number;
          if (serialNumber === undefined) {
            continue;
          }
          if (
            !this.serialNumberArray.includes(
              serialNumber
            )
          ) {
            this.serialNumberArray.push(
              serialNumber
            );
          }
          //aqui se agrega pa assestment al total
          // this.clientReportList.push(this.pa_assessmentsgroup[i]);
        }

        this.getTableDataGeneral();
        this.getInsurer();
        this.getDoctorRBT();
        //  this.getDoctorBcba();
        //  this.extractDataHours();
      });
  }

  getInsurer() {
    if (this.insurance_id === null) {
      return;
    }
    //sacamos los detalles insurance seleccionado
    this.insuranceService.get(this.insurance_id).subscribe(
      (resp: Insurance) => {
        // console.log('insurer', resp);
        this.insuranceiddd = String(resp.id);

        this.insurer_name = resp.insurer_name;
        this.modifiers = resp.notes;
        this.services = resp.services;

        this.provider = resp.services[0]?.provider ?? '';
        this.cpt = resp.services[0]?.code ?? '';
        // el valor de la unidad que viene desde el seguro,
        // ahora debe ser desde la funcion mas abajo
        this.unitPrize = resp.services[0]?.unit_price ?? 0;
        console.log('cpt', this.cpt);

        // Call getPrizeCptNote with the correct parameters from noterbta list and notebcba list
        this.getPrizeCptNote(
          this.insurer_name,
          this.noteBcbaFirstCpt,
          this.noteRbtFirstCpt,
          this.provider
        ).subscribe();
      },
      (error: HttpErrorResponse) => {
        console.error('Error fetching insurance data:', error);
      }
    );
  }
  // funcion para obtener el valor de la unidad del cpt
  getPrizeCptNoteRbt(cptCode: string) {
    this.getPrizeCptNote(
      this.insurer_name,
      this.noteBcbaFirstCpt || cptCode,
      cptCode,
      this.provider
    ).subscribe();
  }

  get noteRbtFirstCpt(): string {
    return this.noteRbt[0]?.cpt_code ?? '';
  }

  get noteBcbaFirstCpt(): string {
    return this.noteBcba[0]?.cpt_code ?? '';
  }

  getUnitPrizes(
    insurerName: string,
    bcbaCptCode: string,
    rbtCptCode: string,
    provider: string
  ): Observable<InsuranceCptPrizeResponse[]> {
    const bcbaObservable = this.insuranceService.showInsuranceCptPrize(
      insurerName,
      bcbaCptCode,
      provider
    ) as Observable<InsuranceCptPrizeResponse>;
    const rbtObservable = this.insuranceService.showInsuranceCptPrize(
      insurerName,
      rbtCptCode,
      provider
    ) as Observable<InsuranceCptPrizeResponse>;

    return forkJoin([bcbaObservable, rbtObservable]).pipe(
      map(
        ([bcbaResponse, rbtResponse]: [
          InsuranceCptPrizeResponse,
          InsuranceCptPrizeResponse
        ]) => {
          return [
            { unit_price: bcbaResponse.unit_price },
            { unit_price: rbtResponse.unit_price },
          ];
        }
      )
    );
  }
  //TODO: replace for a service
  getPrizeCptNote(
    insurer_name: string,
    bcbaCptCode: string,
    rbtCptCode: string,
    provider: string
  ): Observable<InsuranceCptPrizeResponse[]> {
    return this.getUnitPrizes(
      insurer_name,
      bcbaCptCode,
      rbtCptCode,
      provider
    ).pipe(
      tap((result: InsuranceCptPrizeResponse[]) => {
        console.log('Precios unidad', result);
        this.unitPrizeCptBcba = result[0].unit_price;
        this.unitPrizeCptRbt = result[1].unit_price;
      })
    );
  }

  // fin funcion para obtener el valor de la unidad del cpt

  // selectCpt(value:any){
  //   this.selectedCpt = this.combinedList
  //   this.getPrizeCptNote();

  // }

  //trae el nombre del doctor quien hizo la nota rbt
  getDoctorRBT() {
    if (!this.tecnicoRbts) {
      return;
    }
    this.doctorService.showDoctor(this.tecnicoRbts).subscribe((resp) => {
      // console.log('doctor rbt y location',resp);
      this.doctor_selected = resp.user;
      this.full_name = resp.user.full_name;
    });
  }
  // supervisor del tecnico solo sacamos el npi
  getDoctorBcba() {
    if (!this.supervisor) {
      return;
    }
    this.doctorService.showDoctor(this.supervisor).subscribe((resp) => {
      // console.log('bcba',resp);
      this.npi = resp.user.npi;
    });
  }

  extractDataHours() {
    // recorrer el array de billing_general para extraer la data
    const hours_group: string[] = [];
    const units_group: string[] = [];
    const array = this.clientReport_generals;
    for (const report of array) {
      hours_group.push(String(report.total_hours ?? '0'));
      units_group.push(String(report.total_units ?? '0'));
    }
    // console.log(hours_group);
    // console.log(units_group);
    // obtenemos el total de las horas en un rango de 7 dias  atras
    let suma = 0;
    for (
      var i = hours_group.length - 1;
      i >= Math.max(0, hours_group.length - 7);
      i--
    ) {
      suma += parseInt(hours_group[i], 10) || 0;
    }
    void suma;
    // this.week_total_hours = suma / Math.min(7, hours_group.length);// saca el promedio
    // this.week_total_hours = suma ; // saca la suma
    // console.log("total semanal "+ this.week_total_hours );

    // obtenemos el total de las unidades en un rango de 7 dias  atras
    let sumaunit = 0;
    for (
      var i = units_group.length - 1;
      i >= Math.max(0, units_group.length - 7);
      i--
    ) {
      sumaunit += parseInt(units_group[i], 10) || 0;
    }
    // this.week_total_units = sumaunit / Math.min(7, units_group.length);// saca el promedio
    this.week_total_units = sumaunit; // saca la suma
    // console.log("total semanal "+ this.week_total_units );

    // saco el valor de charges multiplicando el total de unidades por semana por el valor del cpt o n_units
    // this.getCharges();
  }

  sortData(sort: Sort) {
    const data = this.clientReportList.slice();

    if (!sort.active || sort.direction === '') {
      this.clientReportList = data;
    } else {
      this.clientReportList = data.sort((a, b) => {
        const aValue = this.getSortValue(a, sort.active);
        const bValue = this.getSortValue(b, sort.active);
        return (aValue < bValue ? -1 : 1) * (sort.direction === 'asc' ? 1 : -1);
      });
    }
  }

  private getSortValue(row: ReportNote, key: string): string {
    const record = row as unknown as Record<string, unknown>;
    const value = record[key];
    return value === null || value === undefined ? '' : String(value).toLowerCase();
  }

  searchData(patientId: string | number) {
    // this.dataSource.filter = value.trim().toLowerCase();
    // this.patientList = this.dataSource.filteredData;
    this.combinedList = [];
    this.pageSelection = [];
    this.limit = this.pageSize;
    this.skip = 0;
    this.currentPage = 1;
    void patientId;
    this.getTableData();
  }

  getTableDataGeneral() {
    this.clientReportList = [];
    this.serialNumberArray = [];
    this.totalDataClientReport = 0;

    this.clientReport_generals.map((res: ReportNote, index: number) => {
      const serialNumber = index + 1;
      if (index >= this.skip && serialNumber <= this.limit) {
        this.clientReportList.push(res);
        this.serialNumberArray.push(serialNumber);
      }
    });
    this.dataSource = new MatTableDataSource<ReportNote>(this.clientReportList);
    // this.calculateTotalPages(this.totalDataClientReport, this.pageSize);

    this.calculateUnitsAndHours();
  }

  calculateUnitsAndHours() {
    const unitsBcba = this.noteBcba.reduce(
      (total, objeto) => total + Number(objeto.session_units_total ?? 0),
      0
    );
    const unitsRbt = this.noteRbt.reduce(
      (total, objeto) => total + Number(objeto.session_units_total ?? 0),
      0
    );
    const totalUnits = unitsBcba + unitsRbt;
    let minutes = 0;
    this.noteRbt.forEach((element) => {
      const [horasRbt, minutosRbt] = String(element.total_hours ?? '0:0').split(':').map(Number);
      minutes += horasRbt * 60 + minutosRbt;
    });
    this.noteBcba.forEach((element) => {
      const [horasBcba, minutosBcba] = String(element.total_hours ?? '0:0')
        .split(':')
        .map(Number);
      minutes += horasBcba * 60 + minutosBcba;
    });
    const horasTotales = Math.floor(minutes / 60);
    const minutosTotales = minutes % 60;
    let stringMinutos: string;
    if (minutosTotales === 0) stringMinutos = '00';
    else if (minutosTotales < 10) stringMinutos = `0${minutosTotales}`;
    else stringMinutos = minutosTotales.toString();

    this.week_total_hours = `${horasTotales} : ${stringMinutos}`;
    this.week_total_units = totalUnits;
  }

  onPaginateChange(event: PageEvent) {
    this.skip = event.pageIndex * this.pageSize;
    this.totalDataClientReport += this.getPageTotal();
    this.getTableDataGeneral();
  }

  getPageTotal(): number {
    const endIndex = Math.min(
      this.skip + this.pageSize,
      this.clientReportList.length
    );
    return this.clientReportList
      .slice(this.skip, endIndex)
      .reduce((acc, cur) => acc + Number(cur.amount ?? 0), 0);
  }

  getMoreData(event: string): void {
    if (event === 'next') {
      this.currentPage++;
      this.pageIndex = this.currentPage - 1;
      this.limit += this.pageSize;
      this.skip = this.pageSize * this.pageIndex;
      this.getTableDataGeneral();
    } else if (event === 'previous') {
      this.currentPage--;
      this.pageIndex = this.currentPage - 1;
      this.limit -= this.pageSize;
      this.skip = this.pageSize * this.pageIndex;
      this.getTableDataGeneral();
    }
  }

  moveToPage(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.skip = this.pageSelection[pageNumber - 1].skip;
    this.limit = this.pageSelection[pageNumber - 1].limit;
    if (pageNumber > this.currentPage) {
      this.pageIndex = pageNumber - 1;
    } else if (pageNumber < this.currentPage) {
      this.pageIndex = pageNumber + 1;
    }
    this.getTableDataGeneral();
  }

  PageSize(): void {
    this.pageSelection = [];
    this.limit = this.pageSize;
    this.skip = 0;
    this.currentPage = 1;
    this.date_start = '';
    this.date_end = '';
    this.ngOnInit();
    this.getTableData();
  }

  private calculateTotalPages(
    totalDatapatient: number,
    pageSize: number
  ): void {
    // this.pageNumberArray = [];
    this.totalPages = totalDatapatient / pageSize;
    if (this.totalPages % 1 !== 0) {
      this.totalPages = Math.trunc(this.totalPages + 1);
    }
    /* eslint no-var: off */
    for (var i = 1; i <= this.totalPages; i++) {
      const limit = pageSize * i;
      const skip = limit - pageSize;
      this.pageNumberArray.push(i);
      this.pageSelection.push({ skip: skip, limit: limit });
    }
  }

  selectUser(biilling: number | string | null) {
    this.billing_selected = biilling;
  }

  addXe(value: number) {
    this.xp = value;
    // console.log(this.xe);
  }

  isSelectedModifier(value: string) {
    this.md = value;
    // console.log(this.md);
  }

  isSelectedModifierBcba(value: string) {
    this.mdbcba = value;
    // console.log(this.mdbcba);
  }

  isSelectedModifier2(value: string) {
    this.md2 = value;
    // console.log(this.md2);
  }

  isSelectedModifier2Bcba(value: string) {
    this.md2bcba = value;
    // console.log(this.md2bcba);
  }

  isCheckedBilled() {
    this.billed = !this.billed;
    // console.log(this.billed);
    // if ( event.target.checked ) {
    // }
  }
  isCheckedBilledBcba() {
    this.billedbcba = !this.billedbcba;
    // console.log(this.billedbcba);
  }

  isCheckedPay() {
    this.pay = !this.pay;
    // console.log(this.pay);
    // if ( event.target.checked ) {
    // }
  }
  isCheckedPayBcba() {
    this.paybcba = !this.paybcba;
    // console.log(this.paybcba);
  }

  save(data: CombinedRow) {
    if (!data.rbt || !data.bcba) {
      return;
    }
    const rbt = data.rbt;
    const bcba = data.bcba;
    let note_rbt_id: number | string | null = null;
    let note_bcba_id: number | string | null = null;

    if (rbt.id) {
      note_rbt_id = rbt.id;
    }

    if (bcba.id) {
      note_bcba_id = bcba.id;
    }

    const VALUE = {
      session_date: rbt.session_date,
      pos: data.pos,
      total_hours: data.total_hours,
      cpt_code: rbt.cpt_code,
      md: this.md,
      md2: this.md2,
      mdbcba: this.mdbcba,
      md2bcba: this.md2bcba,
      xe: this.xp,

      // charges: data.session_units_total * this.unitPrize,
      chargesrbt: Number(rbt.session_units_total ?? 0) * this.unitPrize,
      chargesbcba: Number(bcba.session_units_total ?? 0) * this.unitPrize,
      // total_units: this.n_units,
      total_units: bcba.session_units_total
        ? rbt.session_units_total
        : null,
      pa_number: this.pa_number,

      patient_id: this.patient_id,
      insurer_id: this.insurance_id,
      npi: this.npi,
      note_rbt_id: note_rbt_id,
      note_bcba_id: note_bcba_id,
      billed: rbt.billed,
      pay: rbt.pay,
      billedbcba: bcba.billedbcba,
      paybcba: bcba.paybcba,
    };
    const VALUE2 = {
      session_date: rbt.session_date,
      cpt_code: rbt.cpt_code,
      pos: rbt.pos,
      pa_number: this.pa_number,
      total_hours: rbt.total_hours,
      billed: rbt.billed,
      pay: rbt.pay,
      md: rbt.md,
      md2: rbt.md2,
      note_rbt_id: rbt.id,
      total_units: rbt.session_units_total,
      sponsor_id: rbt.provider_name_g,
      chargesrbt: Number(rbt.session_units_total ?? 0) * this.unitPrize,
      // noterbt_id: data.id,
    };
    const VALUE3 = {
      session_date: bcba.session_date,
      cpt_code: bcba.cpt_code,
      pos: bcba.meet_with_client_at,
      billedbcba: bcba.billedbcba,
      paybcba: bcba.paybcba,
      mdbcba: bcba.mdbcba,
      md2bcba: bcba.md2bcba,
      note_bcba_id: bcba.id,
      total_units: bcba.session_units_total,
      total_hours: bcba.total_hours,
      sponsor_id: bcba.provider_name_g,
      chargesbcba: Number(bcba.session_units_total ?? 0) * this.unitPrize,
      // noterbt_id: data.id,
    };
    // if(this.md2.value === 'XE' ||this.md.value ==='XE')
    //   this.xe= data.total_units * this.unitPrize * this.xe,

    // console.log(VALUE);

    void [VALUE, VALUE2, VALUE3];

    const rbtId = rbt.id;
    const bcbaId = bcba.id;

    if (this.billing_selected) {
      //si  tiene bip se agrega a la informacion de la consulta

      this.clientReportService
        .udpate(VALUE, this.billing_selected)
        .subscribe(() => {
          // console.log(resp);
          // this.text_success = 'Bip Updated'
          Swal.fire('Updated', `Bip Updated successfully!`, 'success');
          this.ngOnInit();
        });
      if (rbtId !== undefined) {
        this.noteRbtService
          .noteUpdateModifier(VALUE2, rbtId)
          .subscribe(() => {
            // console.log(resp);
          });
      }
      if (bcbaId !== undefined) {
        this.noteBCbaService
          .noteBCBAUpdateModifier(VALUE3, bcbaId)
          .subscribe(() => {
            // console.log(resp);
          });
      }
    } else {
      //crear
      this.clientReportService.create(VALUE).subscribe(() => {
        // console.log(resp);
        // this.text_success = 'Se guardó la informacion de la cita médica'
        Swal.fire('Updated', `Added successfully!`, 'success');
        this.ngOnInit();
      });

      if (rbtId !== undefined) {
        this.noteRbtService
          .noteUpdateModifier(VALUE2, rbtId)
          .subscribe(() => {
            // console.log(resp);
          });
      }
      if (bcbaId !== undefined) {
        this.noteBCbaService
          .noteBCBAUpdateModifier(VALUE3, bcbaId)
          .subscribe(() => {
            // console.log(resp);
          });
      }
    }
  }

  cambiarStatus(data: ReportNote) {
    const VALUE = data.status;
    console.log(VALUE);

    const payload = data as Record<string, unknown>;
    if (data.id === undefined) {
      return;
    }
    this.noteRbtService.updateStatus(payload, data.id).subscribe(() => {
      // console.log(resp);
      // Swal.fire('Updated', `Added successfully!`, 'success');
      this.ngOnInit();
    });
  }

  cambiarStatusRbt(data: ReportNote) {
    const payload = data as Record<string, unknown>;
    if (data.id === undefined) {
      return;
    }
    this.noteRbtService.updateStatus(payload, data.id).subscribe(() => {
      this.ngOnInit();
    });
  }

  cambiarStatusBcba(data: ReportNote) {
    const VALUE = data.status;
    console.log(VALUE);

    const payload = data as Record<string, unknown>;
    if (data.id === undefined) {
      return;
    }
    this.noteBCbaService.updateStatus(payload, data.id).subscribe(() => {
      this.ngOnInit();
    });
  }
}
